<template>
  <b-card class="card-tiny-line-stats" body-class="d-flex flex-column justify-content-between pb-0 px-0 pt-0">
    <b-card-header class="p-2">
      <h4 class="mb-0 font-weight-bolder">
        بازدید از منو
      </h4>
      <div class="d-flex align-items-center">
        <h4 class="font-weight-bolder mb-0">{{ amount.toLocaleString('fa-IR') }}</h4>
        <h5 class="ml-50 mb-0">بازدید</h5>
      </div>
    </b-card-header>
    <hr class="m-0">
    <div>
      <vue-apex-charts type="area" height="125" width="100%" :options="options" :series="series" />
    </div>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { BCard, BAvatar, BCardHeader } from 'bootstrap-vue';
export default {
  name: 'visitationChart',
  components: {
    VueApexCharts,
    BCard,
    BAvatar,
    BCardHeader
  },
  props: {
    amount: {
      type: Number,
      default: 0,
    },
    series: {
      type: Array,
      default: () => [],
    },
    optionsCategories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        chart: {
          zoom: { enabled: false },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 2.5
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.9,
            opacityFrom: 0.5,
            opacityTo: 0.2,
            stops: [0, 80, 100]
          }
        },
        grid: {
          show: true,
          padding: {
            left: 0,
            right: 0,
          }
        },
        xaxis: {
          categories: this.optionsCategories,
          tooltip: {
            enabled: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: val => val.toLocaleString('fa-IR') + ' بازدید',
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#7367f0",
            shadeTo: "light",
            shadeIntensity: 0.65
          }
        }
      },
    }
  },
}
</script>